import React from "react";
import ReactDOM from "react-dom";
// import LogRocket from 'logrocket';
import { unregister as unregisterServiceWorker } from './registerServiceWorker'
import { AppContainer } from 'react-hot-loader';

import CircularProgress from "components/CircularProgress/index";
import NextApp from './NextApp';
import axios from "axios";
import { history } from "./appRedux/store";
import { getPath } from "./util/logoHelper";
import "./util/dedupeAlerts";

//Environment
window.environment = 'Development';
window.ApiURL = window.__RUNTIME_CONFIG__.REACT_APP_BASE_API_URL;
window.ApiURLNew = window.__RUNTIME_CONFIG__.REACT_APP_BASE_API_URL_NEW;

// Setup Axios Interceptors for Global 401 & 403 response code handling
axios.interceptors.response.use(
  (response) => {
    // Some successful 200 responses contain ERROR37 or AUTH401 in their payload
    const data = response && response.data;
    if (data) {
      if (data.responseStatus === "ERROR37" || data.responseCode === "ERROR37" || (data.abstractResponse && data.abstractResponse.responseStatus === "ERROR37")) {
        history.push(getPath("/forbidden"));
      }
    }
    return response;
  },
  (error) => {
    if (error && error.response) {
      const { status, data } = error.response;
      if (status === 401) {
        error.response.data = {
          responseCode: "AUTH401",
          responseMessage: "Unauthorized",
          body: null,
          paging: null,
          abstractResponse: {
            responseStatus: "AUTH001",
            responseMessage: "Unauthorized"
          }
        };
      } else if (status === 403 || (data && data.responseStatus === "ERROR37")) {
        error.response.data = {
          responseStatus: "ERROR37",
          responseMessage: "Access Denied"
        };
        history.push(getPath("/forbidden"));
      }
    }
    return Promise.reject(error);
  }
);

// Wrap the rendering in a function:
const render = Component => {
  // === Normalize URL (hapus trailing slash) ===
  (function normalizeUrl() {
    const path = window.location.pathname;
    if (path.length > 1 && path.endsWith('/')) {
      const normalized = path.replace(/\/+$/, ''); // hapus semua slash di akhir
      window.location.replace(normalized + window.location.search + window.location.hash);
    }
  })();
  // ============================================
  ReactDOM.render(
    <AppContainer>
      <React.Suspense fallback={
        <div className="gx-loader-view">
          <CircularProgress />
        </div>
      }>
        <NextApp/>
      </React.Suspense>
    </AppContainer>,
    document.getElementById('root')
  );
};

// Service Worker
unregisterServiceWorker();

// Render once
render(NextApp);

// Webpack Hot Module Replacement API
if (module.hot) {
  module.hot.accept('./NextApp', () => {
    render(NextApp);
  });
}
